"use client";

import { c as _c } from "react/compiler-runtime";
import { Button } from "@/components/ui";
interface Props {
  /** What failed to load, e.g. "lab orders". */
  label: string;
  onRetry: () => void;
  isRetrying?: boolean;
}

/** A failed read, kept distinct from an empty clinical record. */
export function SectionLoadError(t0) {
  const $ = _c(8);
  const {
    label,
    onRetry,
    isRetrying
  } = t0;
  let t1;
  if ($[0] !== label) {
    t1 = <p className="text-caption text-status-error-text">Couldn't load {label}.</p>;
    $[0] = label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== isRetrying || $[3] !== onRetry) {
    t2 = <Button variant="ghost" className="p-1 text-primary" onClick={onRetry} isLoading={isRetrying}>Retry</Button>;
    $[2] = isRetrying;
    $[3] = onRetry;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <div className="flex items-center justify-between gap-2">{t1}{t2}</div>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}